<template>
  <b-modal id="vulnerabilityDetailsModal" size="lg" hide-header-close no-stacking :title="$t('message.vulnerability_details')">
    <b-tabs class="body-bg-color" style="border:0;padding:0">
      <b-tab class="body-bg-color" style="border:0;padding:0" active>
        <template v-slot:title> {{ $t('message.general') }} </template>
        <b-card>
          <b-input-group-form-input id="vuln-source-input" input-group-size="mb-3" type="text" v-model="vulnerability.source"
                                    lazy="true" required="false" autofocus="false" disabled="true"
                                    :label="$t('message.vulnerability_source')" :tooltip="this.$t('message.vulnerability_source_desc')"/>

          <b-input-group-form-input id="vuln-vulnId-input" input-group-size="mb-3" type="text" v-model="vulnerability.vulnId"
                                    lazy="true" required="false" autofocus="false" disabled="true"
                                    :label="$t('message.vulnerability_vuln_id')" :tooltip="this.$t('message.vulnerability_vuln_id_desc')"/>

          <b-input-group-form-input id="vuln-title-input" input-group-size="mb-3" type="text" v-model="vulnerability.title"
                                    lazy="true" required="false" autofocus="false" disabled="true"
                                    :label="$t('message.vulnerability_title')" :tooltip="$t('message.vulnerability_title_desc')" />

          <b-input-group-form-input id="vuln-subtitle-input" input-group-size="mb-3" type="text" v-model="vulnerability.subtitle"
                                    lazy="true" required="false" autofocus="false" disabled="true"
                                    :label="$t('message.vulnerability_subtitle')" :tooltip="$t('message.vulnerability_subtitle_desc')" />

          <b-input-group-form-input id="vulnerability-uuid" input-group-size="mb-3" type="text" v-model="vulnerability.uuid"
                                    lazy="false" required="false" feedback="false" autofocus="false" disabled="true"
                                    :label="$t('message.object_identifier')" :tooltip="this.$t('message.object_identifier_desc')"
                                    :readonly="true" />
        </b-card>
      </b-tab>
      <b-tab class="body-bg-color" style="border:0;padding:0">
        <template v-slot:title> {{ $t('message.details') }} </template>
        <b-card>
          <b-form-group id="vuln-description-fieldset" :label="this.$t('message.description')" label-for="vuln-description-input">
            <b-form-textarea id="vuln-description-input" v-model="vulnerability.description" rows="4" disabled class="form-control disabled" readonly trim />
          </b-form-group>
          <b-form-group id="vuln-recommendation-fieldset" :label="this.$t('message.recommendation')" label-for="vuln-recommendation-input">
            <b-form-textarea id="vuln-recommendation-input" v-model="vulnerability.recommendation" rows="4" disabled class="form-control disabled" readonly trim />
          </b-form-group>
          <b-form-group id="vuln-references-fieldset" :label="this.$t('message.references')" label-for="vuln-references-input">
            <b-form-textarea id="vuln-references-input" v-model="vulnerability.references" rows="4" disabled class="form-control disabled" readonly trim />
          </b-form-group>
          <b-form-group id="vuln-credits-fieldset" :label="this.$t('message.credits')" label-for="vuln-credits-input">
            <b-form-textarea id="vuln-credits-input" v-model="vulnerability.credits" rows="2" disabled class="form-control disabled" readonly trim />
          </b-form-group>
        </b-card>
      </b-tab>
      <!--
      <b-tab class="body-bg-color" style="border:0;padding:0">
        <template v-slot:title> {{ $t('message.cvss_v2') }} </template>
        <b-card>
        </b-card>
      </b-tab>
      <b-tab class="body-bg-color" style="border:0;padding:0">
        <template v-slot:title> {{ $t('message.cvss_v3') }} </template>
        <b-card>
        </b-card>
      </b-tab>
      <b-tab class="body-bg-color" style="border:0;padding:0">
        <template v-slot:title> {{ $t('message.affects') }} </template>
        <b-card>
        </b-card>
      </b-tab>
      -->
    </b-tabs>
    <template v-slot:modal-footer="{ cancel }">
      <b-button size="md" variant="outline-primary" @click="cancel()">{{ $t('message.close') }}</b-button>
    </template>
  </b-modal>
</template>

<script>
  import permissionsMixin from "../../../mixins/permissionsMixin";
  import BInputGroupFormInput from "../../../forms/BInputGroupFormInput";
  import common from "../../../shared/common";

  export default {
    name: "VulnerabilityDetailsModal",
    mixins: [permissionsMixin],
    components: {
      BInputGroupFormInput
    },
    props: {
      vulnerability: Object
    }
  }
</script>

<style scoped>
  .tab-content .tab-pane{
    padding: 0 !important;
  }
  .tab-content {
    border: 0 !important;
  }
  .card {
    border:0;
    padding:0;
    margin-bottom:0;
  }
</style>
